<template>
  <div class="matrixradio-chart">
    <el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="subTitles" label="子问题" width="600">
          <template slot-scope="scope">{{ scope.row.text }}</template>
        </el-table-column>
        <el-table-column prop="count" v-for="(opt, i) in answerOpts" :label="opt.text" :key="i">
          <template slot-scope="scope">{{ scope.row.answerOptions[i].count }}</template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="showChart">
      <div class="type-selector">
        <el-radio-group v-model="chartType" @change="handleChangeType" size="medium">
          <el-radio-button label="柱状图"></el-radio-button>
          <el-radio-button label="条形图"></el-radio-button>
          <el-radio-button label="折线图"></el-radio-button>
        </el-radio-group>
      </div>
      <vue-highcharts v-show="chartType == '条形图'" :options="barOptions" ref="barCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '柱状图'" :options="columnOptions" ref="columnCharts"></vue-highcharts>
      <vue-highcharts v-show="chartType == '折线图'" :options="lineOptions" ref="lineCharts"></vue-highcharts>
    </el-row>
  </div>
</template>

<script>
import VueHighcharts from "vue2-highcharts";
export default {
  name: "matrixRadioChart",
  props: ["quesInfo", "showChart"],
  components: {
    VueHighcharts
  },
  computed: {
    answerOpts() {
      return this.quesInfo.groupMatrixList[0].answerOptions;
    },
    subTitlesArr() {
      let _arr = [];
      this.quesInfo.groupMatrixList.forEach(val => {
        _arr.push(val.text);
      });
      return _arr;
    },
    series() {
      let _opt = [];
      this.answerOpts.forEach(opt => {
        _opt.push({
          name: opt.text,
          data: []
        });
      });
      this.quesInfo.groupMatrixList.forEach(val => {
        val.answerOptions.forEach((opt, i) => {
          _opt[i].data.push(opt.count);
        });
      });
      return _opt;
    },
    barOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.subTitlesArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b>' +
            "({point.percentage:.0f}%)<br/>",
          //:.0f 表示保留 0 位小数，详见教程：https://www.hcharts.cn/docs/basic-labels-string-formatting
          shared: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        series: this.series
      };
    },
    columnOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.subTitlesArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b>' +
            "({point.percentage:.0f}%)<br/>",
          //:.0f 表示保留 0 位小数，详见教程：https://www.hcharts.cn/docs/basic-labels-string-formatting
          shared: true
        },
        plotOptions: {
          series: {
            stacking: "percent"
          }
        },
        series: this.series
      };
    },
    lineOptions() {
      return {
        chart: {
          type: "line"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: this.subTitlesArr
        },
        yAxis: {
          title: {
            text: ""
          }
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b>' +
            "({point.percentage:.0f}%)<br/>",
          //:.0f 表示保留 0 位小数，详见教程：https://www.hcharts.cn/docs/basic-labels-string-formatting
          shared: true
        },
        plotOptions: {
          // series: {
          //     stacking: 'percent'
          // }
        },
        series: this.series
      };
    },
    tableData() {
      return this.quesInfo.groupMatrixList;
    }
  },
  data() {
    return {
      loaded: false,
      chartType: "条形图",
      typeMap: { 柱状图: "column", 条形图: "bar", 折线图: "line" }
    };
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    handleChangeType(val) {
      let _chart = this.$refs[this.typeMap[val] + "Charts"];
      _chart.removeSeries();
      this.series.forEach(val => {
        _chart.addSeries(val);
      });
    }
  }
};
</script>

<style lang="scss">
.matrixradio-chart {
  .type-selector {
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/singleAnalysis/matrixRadioChart.vue